<svelte:options tag='swc-terms-and-conditions' immutable={true} />

<style>
  span {
    display: block;
    font-size: 0.75em;
    line-height: 1.5;
    opacity: 0.6;
    text-align: center;
  }
  a {
    text-decoration: underline;
    color: #111155;
  }
</style>

<span>
  By continuing, you agree to our
  <a href='https://switchcraft.co.uk/terms' target='_blank'>terms</a> and
  <a href='https://www.switchcraft.co.uk/privacy/' target='_blank'>privacy policy</a>.
</span>
